import * as React from 'react';
import { CSSProperties } from 'react';

interface IFaIconProps {
  icon: string;
  style?: CSSProperties;
}

export default class FaIcon extends React.Component<IFaIconProps, {}> {
  render() {
    return (
      <i className={`fa fa-${this.props.icon} fa-fw`} style={this.props.style} />
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/FaIcon.tsx